import { Component, inject, Input, OnInit } from '@angular/core';
import { Indicator } from '../../../models/indicator';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { hasMeaningfulContent } from '../../../utility/app.utility';
import { WegweiserIndicator } from '../../../services/grid-widget-config.service';

@Component({
  selector: 'app-indicator-meta-data',
  standalone: true,
  imports: [],
  templateUrl: './indicator-meta-data.component.html',
  styleUrl: './indicator-meta-data.component.scss',
})
export class IndicatorMetaDataComponent implements OnInit {
  readonly indicatorStore = inject(IndicatorStore);
  @Input() indicator!: Indicator;
  @Input() parent?: Indicator;

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * This method retrieves and sets the parent indicator from the indicator store, based on the current indicator's parent ID.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    if (this.indicator.parent) {
      this.parent = this.indicatorStore.getById(this.indicator.parent);
    }
  }

  protected readonly hasMeaningfulContent = hasMeaningfulContent;
}
